import { DAIMI_RT_INTRO, DAIMI_RT_SLUG } from '@/content/daimiRetail'
import { focus } from '@/content/reportBuilder'
import type { Report } from '@/content/reportBuilder'

export const report: Report = {
  // The twenty-fifth report with a designed page of its own, and the tenth focus
  // cut to arrive with both of its figures — asked for on 2026-08-28 in the same
  // words as the Services cut earlier the same day (*"referans alarak ilgili
  // sayfayı birebir tıpa tıp aynısını tasarla"*) with a four-part full-page capture
  // of the live page, the cover as two overlapping 2000px crops, Figure 1 and the
  // report mockup. See `content/daimiRetail.ts` and `pages/DaimiRetail.tsx`. Not to
  // be confused with the Future 2030 Retail outlook further down, which is a
  // separate report on `'retail-outlook'`.
  ...focus(
    DAIMI_RT_SLUG,
    'Retail',
    'daimi-report-2026-retail-cover',
    '90962db6-0b42-4f3f-a562-ace423a11e6f-digitopia-daimi-2026-report-retail.pdf',
  ),
  // The sector's own paragraphs, transcribed from the reference capture and held
  // on the page that says them — so the search result and the page cannot drift
  // apart. `prerender.tsx` takes the meta description from `body[0]`.
  body: DAIMI_RT_INTRO.body,
  layout: 'retail-focus',
  // Its own words, its cover, its file and both of its figures, so `stillToCome`
  // has nothing left to say about it. What is still open is section-by-section on
  // its page, and `daimiRetailChecks()` carries that into the manifest.
  check: undefined,
}

/** Its place in the index grid — the order the imported page listed them. */
export const order = 15
